import React from 'react';
import './EducativeModel.scss';

const EducativeModel = () => {
    return (
        <div className="educative-model">
            {/* Contenido oculto temporalmente por solicitud de rediseño */}
        </div>
    );
};

export default EducativeModel;